import type { ErrorInfo } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { addReactError } from '@datadog/browser-rum-react';

/** RUM queues reports until it starts, so reporting before init would hold every error forever. */
export const reportReactError = (error: unknown, errorInfo: ErrorInfo = { componentStack: '' }) => {
  if (datadogRum.getInitConfiguration()) addReactError(error, errorInfo);
};
